import {useApiQuery} from 'src/hooks/useApiQuery';
import type {
  AssetListResponse,
  ConversationListResponse,
} from 'src/types/ask-ai';


export const LAST_MODE_STORAGE_KEY = 'askai:chatMode';
export const POSITION_PERSIST_KEY = 'askai:chatPos';
export const PANEL_LEFT_MARGIN = 0;
export const SIDENAV_EXPANDED_WIDTH = 240;
export const SIDENAV_COLLAPSED_WIDTH = 60;
export const FULLSCREEN_MODE_KEY = 'fscr';
export const ASSET_ID_QUERY_KEY = 'assetId';
export const DEFAULT_ASK_AI_ELEVATION = 2000;
export const DEFAULT_CONVERSATION_NAME = 'Untitled conversation';

export const getMessageHistoryQueryKey = (threadId: string) => [
  'message-history',
  threadId,
];

export const CONVERSATION_LIST_QUERY_KEY = ['conversation-list'] as const;
export const ASSET_LIST_QUERY_KEY = ['asset-list'] as const;

export function useConversationListQuery({
  enabled = true,
}: {enabled?: boolean} = {}) {
  return useApiQuery<ConversationListResponse>('conversation', {
    queryOptions: {queryKey: CONVERSATION_LIST_QUERY_KEY, enabled},
    apiOptions: {
      method: 'GET',
      options: {
        apiPath: '/grace/api/v1/',
      },
    },
  });
}

export function useAssetListQuery({enabled = true}: {enabled?: boolean} = {}) {
  return useApiQuery<AssetListResponse>('assets', {
    queryOptions: {queryKey: ASSET_LIST_QUERY_KEY, enabled},
    apiOptions: {
      method: 'GET',
      options: {
        apiPath: '/grace/api/v1/',
      },
    },
  });
}

export function formatConversationLastModifiedAt(raw?: string) {
  if (!raw) {
    return '';
  }

  const date = new Date(raw);

  if (Number.isNaN(date.getTime())) {
    return raw;
  }

  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}
